import axios from "axios";
import { toast } from "react-toastify";
import { Apis, BaseUrl } from "../../config";
import { getSession } from "../authActions";

export const addToCart = (cartData) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_to_cart_request" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.cartItem}`, cartData, {
      headers: { Authorization: `Bearer ${token}` },
    });

    dispatch({
      type: "add_to_cart_success",
    });

    localStorage.setItem("cartId", response.data.usr?.rec[0]);
    toast.success("Item added to cart successfully!");
  } catch (error) {
    dispatch({
      type: "add_to_cart_failure",
      payload: error?.response?.data,
    });
    toast.error("Failed to add item to cart.");
  }
};

export const updateCart = (cartData) => async (dispatch) => {
  const { token, user_profile_id } = getSession();

  dispatch({ type: "update_cart_request" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.cartItem}/${user_profile_id}`,
      cartData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    dispatch({
      type: "update_cart_success",
    });
    toast.success(response.data.usr.message || "Cart updated successfully!");
  } catch (error) {
    dispatch({
      type: "update_cart_failure",
      payload: error?.response?.data,
    });
    toast.error("Failed to update cart.");
  }
};

export const getCartItems = () => async (dispatch) => {
  const { token, user_profile_id } = getSession();

  dispatch({ type: "get_cart_list" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.cartItem}/${user_profile_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    dispatch({
      type: "cart_list_success",
      payload: response.data.usr.rec || [],
    });
    return response.data.usr.rec;
  } catch (error) {
    dispatch({
      type: "cart_list_failure",
      payload: error?.response?.data,
    });

    toast.error(
      error?.response?.data?.usr?.message || "Failed to fetch cart items."
    );
  }
};

export const deleteCart = (data) => async (dispatch) => {
  const { token, user_profile_id } = getSession();
  localStorage.removeItem("cartId");
  dispatch({ type: "delete_cart_success" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.cartItem}/${user_profile_id}`,
      data,

      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    dispatch({
      type: "update_cart_success",
      payload: response.data.usr.rec,
    });
    toast.success(response.data.usr.message || "Cart updated successfully!");
  } catch (error) {
    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};

export const deletePatient = (patient_id) => async (dispatch) => {
  const { token, role_id } = getSession();

  dispatch({ type: "patient_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.updatePatient}${patient_id}`,
      {
        svc_active_yn: "N",
        sys_user_id: patient_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "patient_delete", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "patient_delete_failure",
      payload: error.response.data,
    });

    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};
